import { Link } from "react-router-dom";
import { chatMessages, chatRooms } from "@/mocks/chat";

export default function ChatPreview() {
  const room = chatRooms[0];
  const preview = chatMessages.slice(0, 6);

  return (
    <section id="chat" className="w-full px-4 md:px-10 py-16 md:py-24 bg-secondary-950">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
        <div className="lg:col-span-5">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-accent-300 bg-accent-500/15 px-3 py-1 rounded-full">
            <i className="ri-live-line w-4 h-4 flex items-center justify-center"></i>
            聊天室实时同步
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-bold text-background-50 leading-snug">
            一个人刷是消遣，
            <br />
            一群人蹲才叫上瘾
          </h2>
          <p className="mt-4 text-sm md:text-base text-secondary-200 leading-relaxed">
            主瓜田、综艺蹲守屋、反转档案馆……每个房间都有各自的节奏。有人负责抛料，有人负责考据，还有人专门整理时间线。
          </p>
          <ul className="mt-6 space-y-3 text-sm text-secondary-100">
            {[
              "进展第一时间同步，不用反复刷新",
              "房间按兴趣划分，聊得更对味",
              "管理员随时降温，氛围轻松不吵架",
            ].map((text) => (
              <li key={text} className="flex items-center gap-2.5">
                <i className="ri-checkbox-circle-fill w-5 h-5 flex items-center justify-center text-accent-400"></i>
                {text}
              </li>
            ))}
          </ul>
          <Link
            to="/chat"
            className="mt-8 inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-chat-smile-2-line w-5 h-5 flex items-center justify-center"></i>
            进入聊天室
          </Link>
        </div>

        <div className="lg:col-span-7">
          <div className="rounded-lg bg-background-50 border border-background-300 overflow-hidden">
            <div className="px-5 py-4 border-b border-background-200 flex items-center justify-between">
              <div className="flex items-center gap-2.5">
                <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                  <i className={`${room.icon} w-5 h-5 flex items-center justify-center`}></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{room.name}</p>
                  <p className="text-xs text-foreground-500">{room.desc}</p>
                </div>
              </div>
              <span className="flex items-center gap-1.5 text-xs text-primary-600">
                <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulseSoft"></span>
                {room.online.toLocaleString()} 在线
              </span>
            </div>
            <div className="p-5 space-y-4">
              {preview.map((msg) => (
                <div key={msg.id} className="flex items-start gap-3">
                  <span className="w-9 h-9 shrink-0 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center text-base">
                    <i className={`${msg.avatar} w-5 h-5 flex items-center justify-center`}></i>
                  </span>
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 text-xs">
                      <span className="font-medium text-foreground-900">{msg.user}</span>
                      {msg.tag ? (
                        <span className="px-1.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-[10px]">
                          {msg.tag}
                        </span>
                      ) : null}
                      <span className="text-foreground-400">{msg.time}</span>
                    </div>
                    <p className="mt-1 text-sm text-foreground-700 leading-relaxed">{msg.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}